import { configureStore } from '@reduxjs/toolkit';
import TemplateJsonSlice from './TemplateJsonSlice';
import AttributeItemSlice from './AttributeItemSlice';
import EventItemSlice from './EventItemSlice';
import ScriptItemSlice from './ScriptItemSlice';
import ServiceWorkerItemSlice from './ServiceWorkerItemSlice';
import AppSettingSlice from './AppSettingSlice';
import EditorJsonVersionSlice from './EditorJsonVersionSlice';
import ToolBoxItemSlice from './ToolBoxItemSlice';
import TestItemSlice from './TestItemSlice';

export const editorDataStore = configureStore({
    reducer: {
        appSettings: AppSettingSlice,
        attributeItems: AttributeItemSlice,
        eventItems: EventItemSlice,
        scriptItems: ScriptItemSlice,
        serviceWorkerItems: ServiceWorkerItemSlice,
        templateItems: TemplateJsonSlice,
        toolBoxItems: ToolBoxItemSlice,
        editorJsonVersion : EditorJsonVersionSlice,
        testItems: TestItemSlice,
    },
});